/**
 * Atlas eligibility uses `on_map`. Placement uses `latitude` / `longitude`.
 *
 * Studio does not enable Atlas from Publish — Argon Atlas owns import/placement.
 * Atlas-enabled but unplaced: `on_map === true` and coordinates are null.
 * Do not invent coordinates in Studio.
 */

export const ATLAS_APP_URL = "https://atlas.argon-web.io";

export function isAtlasEnabled(project) {
  return Boolean(project?.on_map);
}

export function isAtlasPlaced(project) {
  return (
    isAtlasEnabled(project) &&
    project?.latitude != null &&
    project?.longitude != null
  );
}

export function isAtlasUnplaced(project) {
  return isAtlasEnabled(project) && !isAtlasPlaced(project);
}

/** Preserve Atlas flags on edit without sending fake coordinates. */
export function atlasFieldsFromProject(project) {
  const fields = { on_map: Boolean(project?.on_map) };
  if (project?.latitude != null) fields.latitude = project.latitude;
  if (project?.longitude != null) fields.longitude = project.longitude;
  return fields;
}
